<template>
  <div class="main-wraper">
    <div class="rigt_navbar" style="text-align: left" id="content">
      <h3 class="main_header display_non">Quality Control</h3>
      <div class="invoic_srch">
        <div class="qualit_srcw pdong_btm">
          <h3 class="sub_header1">Toat Number</h3>
          <form @submit.prevent="searchInventoryByToat(toatNumber)">
            <div class="form_group1">
              <i class="fa fa-search" aria-hidden="true"></i>
              <input
                class="search_form"
                type="text"
                v-model="toatNumber"
                placeholder="Scan or Enter the Toat Number"
              />
              <div v-if="errors1.includes('invalid_toat')">
                <div class="warning_img">
                  <div class="warnig_imgw">
                    <img src="@/assets/images/icons/warning.svg" />Please check
                    the Toat Number
                  </div>
                </div>
              </div>
            </div>
            <button class="main_button">Search</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QualityControl",
  data() {
    return {
      toatNumber: "",
      errors1: [],
    };
  },
  methods: {
    searchInventoryByToat(toatNumber) {
      if (toatNumber !== "") {
        let searchParam = {
          params: {
            toat_number: toatNumber,
          },
        };
        this.$httpSecured
          .get(
            "/api/v1/warehouse/quality_control/fetch_inventories",
            searchParam,
          )
          .then((response) => {
            if (response.data.inventories.length !== 0) {
              this.$store.commit("setQc", {
                toat_number: this.toatNumber,
                inventories: response.data,
              });
              this.$router.push({ name: "QualityControlList" });
            } else {
              this.errors1.push("invalid_toat");
              this.toatNumber = "";
            }
          })
          .catch(() => {
            this.$toast.error("Error in fetching Inventories");
            this.errors1.push("invalid_toat");
            this.toatNumber = "";
          });
      } else {
        this.errors1.push("invalid_toat");
        this.toatNumber = "";
      }
    },
  },
};
</script>
